import { render, staticRenderFns } from "./2_location.vue?vue&type=template&id=0e8e8e0c&"
import script from "./2_location.vue?vue&type=script&lang=js&"
export * from "./2_location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports